import {Component, computed, signal} from '@angular/core';
import {CodaltComponent} from '../codalt.component';
import {MatCheckbox} from '@angular/material/checkbox';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {DatePipe, PercentPipe} from '@angular/common';
import {Clipboard} from '@angular/cdk/clipboard';
import {UrlPrefixStrippingPipe} from '../pipes/url-prefix-stripping.pipe';
import {SafeResourceUrlPipe} from '../pipes/safe-resource-url.pipe';
import {MinutesPipe} from '../pipes/minutes.pipe';
import {ProfileTotals, RegistrationService} from '../services/registration.service';
import {AuthorisationService} from '../services/auth/authorisation.service';
import {Roles} from '../services/auth/roles';
import {UserAssignment} from '../classes/user-assignment.class';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    imports: [
        MatCheckbox,
        ReactiveFormsModule,
        DatePipe,
        PercentPipe,
        UrlPrefixStrippingPipe,
        SafeResourceUrlPipe,
        MinutesPipe
    ]
})
export class ProfileComponent extends CodaltComponent {

    showOwnMail = new FormControl(false);
    readonly urlCopied = signal<boolean>(false);
    readonly urlCopiedOwn = signal<boolean>(false);
    readonly base64Image = signal<string | null>(null);
    readonly totals = signal<ProfileTotals | null>(null);
    readonly isManagement = AuthorisationService.hasRole(Roles.Management);
    readonly UserAssignment = UserAssignment;
    readonly overview = signal<ProfileTotals[] | null>(null);
    // Years with registrations of any user, newest first; each row gets one entry per year
    readonly overviewYears = computed(() => [...new Set(this.overview()?.flatMap(u => u.per_year.map(y => y.year)))].sort((a, b) => b - a));
    readonly overviewRows = computed(() => this.overview()?.map(user => ({
        ...user,
        years: this.overviewYears().map(year => user.per_year.find(y => y.year === year) ?? null)
    })));

    constructor(private clipboard: Clipboard,
                private registrationService: RegistrationService) {
        super();

        this.loadEmailImage();
        this.subscriptions.add(
            this.registrationService.getProfileTotals().subscribe(totals => this.totals.set(totals))
        );
        if (this.isManagement) {
            this.subscriptions.add(
                this.registrationService.getProfileTotalsOverview().subscribe(overview => this.overview.set(overview))
            );
        }
    }

    private async loadEmailImage() {
        const response = await fetch('/assets/images/email-codalt.png');
        const blob = await response.blob();
        const dataUrl = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
        this.base64Image.set(dataUrl);
    }

    copyUrlShare(onlyMe = false) {
        if (this.clipboard.copy(this.environment.apiEndpoint + 'ical/' + this.LocalStorage.user.calendarUrl + (onlyMe ? '?onlyMe=true' : ''))) {
            if (onlyMe) {
                this.urlCopiedOwn.set(true);
            } else {
                this.urlCopied.set(true);
            }
            setTimeout(() => {
                this.urlCopiedOwn.set(false);
                this.urlCopied.set(false);
            }, 5000);
        }
    }
}

